class ScrollSpy {
    constructor({ menu, container, activeClass = 'active' }) {
        this.menu = document.querySelector(menu);
        this.container = document.querySelector(container);
        this.activeClass = activeClass;
        this.sections = []; // Sections to spy on
        this.links = []; // Navigation links

        if (this.menu && this.container) {
            this.init();
        }
    }

    init() {
        this.getSections();
        this.observeSections();
        this.bindClick();
    }

    getSections() {
        this.links = Array.from(this.menu.querySelectorAll('a[href^="#"]'));
        this.sections = this.links.map(link => {
            const id = link.getAttribute('href');
            if (id === '#' || !id) return null; // Ignore empty or invalid links
            return document.querySelector(id);
        }).filter(section => section !== null);
    }

    observeSections() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.links.forEach(link => link.classList.remove(this.activeClass));
                    let activeLink = this.menu.querySelector(`a[href="#${entry.target.id}"]`);
                    if (activeLink) {
                        activeLink.classList.add(this.activeClass);
                        
                        // Highlight parent menu item if it exists
                        let parentItem = activeLink.closest('ul')?.closest('li')?.querySelector('a');
                        if (parentItem) {
                            parentItem.classList.add(this.activeClass);
                        }
                    }
                }
            });
        }, { threshold: 0.5 }); // Adjust threshold as needed

        this.sections.forEach(section => observer.observe(section));
    }

    bindClick() {
        this.links.forEach(link => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                const targetId = link.getAttribute('href');

                if (targetId === '#' || !targetId) return; // Ignore empty or invalid links

                const targetElement = document.querySelector(targetId);
                
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth' });
                }
            });
        });
    }
}

export default ScrollSpy;
